import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import CircularProgress from "@mui/material/CircularProgress";
import { colors } from "../../utils";

// Keyframes for fade animation
const fadeAnimation = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 1;
  }
`;

// Styled button component
const StyledButton = styled.button`
  background-color: ${colors.PrimaryPurple500};
  color: white;
  outline: none;
  border-radius: 4px;
  border: none;
  min-height: 32px;
  width: 100%;
  text-align: center;
  font-family: "DM Sans", sans-serif;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: opacity 0.2s ease;

  &.secondary {
    background-color: transparent;
    color: #565556;
  }

  &.outlined {
    color: ${colors.PrimaryPurple};
    border: 1px solid ${colors.PrimaryPurple};
    background-color: white;
  }

  &.disabled {
    color: #333333;
    background-color: ${colors.lightGrey};
    border: 1px solid ${colors.lightGrey};
  }

  &.button-clicked {
    animation: ${fadeAnimation} 0.5s ease;
  }
`;

const Button = ({
  onClick = () => {},
  isLoading,
  children,
  disabled,
  secondary,
  variant,
  type = "button",
  loaderSize = 20,
  width,
  ...props
}) => {
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const handleClick = (e) => {
    if (type !== "submit") {
      e.stopPropagation();
    }
    setIsButtonClicked(true);
    onClick(e);
    setTimeout(() => {
      setIsButtonClicked(false);
    }, 500);
  };

  return (
    <StyledButton
      disabled={disabled || isLoading}
      type={type}
      className={`${secondary ? "secondary" : ""} ${
        isButtonClicked ? "button-clicked" : ""
      } ${variant} ${disabled ? "disabled" : ""} ${
        width ? "w-auto" : "w-full"
      }`}
      onClick={handleClick}
      {...props}
    >
      {isLoading && (
        <CircularProgress
          size={loaderSize}
          style={{ color: "white", marginTop: 4, marginRight: 4 }}
        />
      )}
      {children}
    </StyledButton>
  );
};

export default Button;
